import lake from "../../../images/tours/georgia/pexels-alina-rossoshanska-338724645-20861078.jpg";
import buildings from "../../../images/tours/georgia/pexels-paul-28750740.jpg";
import egg from "../../../images/tours/georgia/pexels-nadin-sh-78971847-15573644.jpg";
import wine from "../../../images/tours/georgia/pexels-freestockpro-9397571.jpg";
import stairs from "../../../images/tours/georgia/pexels-julia-volk-5272956.jpg";
import colons from "../../../images/tours/georgia/pexels-vladimir-konoplev-155326297-11885398.jpg";
import React from "react";
import ImagesSection from "../common/ImagesSection";

const imageList = [
    {imageUrl: lake, text: 'georgia_img1'},
    {imageUrl: buildings, text: 'georgia_img2'},
    {imageUrl: wine, text: 'georgia_img3'},
    {imageUrl: egg, text: 'georgia_img4'},
    {imageUrl: stairs, text: 'georgia_img5'},
    {imageUrl: colons, text: 'georgia_img6'},
];

const GeorgiaImagesSection = () => {
    return (
        <ImagesSection imageList={imageList}/>
    );
}

export default GeorgiaImagesSection;
